(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wubs-company-reviews-variants"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('wubs-company-review-showcase')) return;

    class WubsCompanyReviewShowcase extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'compare';
        this.limit = Math.max(3, Number(this.dataset.limit) || 9);
        this.visibleCount = Math.max(3, Math.min(4, Number(this.dataset.visibleCount) || 4));
        this.minimumRating = Math.max(1, Number(this.dataset.minRating) || 1);
        this.targetLanguage = (this.dataset.locale || document.documentElement.lang || 'sv').split('-')[0].toLocaleLowerCase();
        this.translationCache = new Map();
        this.translationStorageKey = `wubs-company-review-translations:${this.targetLanguage}`;
        this.restoreTranslationCache();
        this.totalReviewCount = 0;
        this.content = this.querySelector('.wubs-company-reviews__content');
        this.loading = this.querySelector('.wubs-company-reviews__loading');
        this.error = this.querySelector('.wubs-company-reviews__error');
        this.onReviewToggle = (event) => {
          const button = event.target.closest?.('[data-review-more]');
          if (!button || !this.contains(button)) return;

          const text = button.previousElementSibling;
          if (!text?.matches('[data-review-text]')) return;

          const expanded = button.getAttribute('aria-expanded') === 'true';
          text.classList.toggle('is-expanded', !expanded);
          button.closest('.wubs-company-reviews__review-card')?.classList.toggle('is-expanded', !expanded);
          button.setAttribute('aria-expanded', String(!expanded));
          button.textContent = expanded ? 'Læs mere' : 'Vis mindre';
        };
        this.addEventListener('click', this.onReviewToggle);
        this.init();
      }

      disconnectedCallback() {
        this.clearSliderBindings();
        this.removeEventListener('click', this.onReviewToggle);
        cancelAnimationFrame(this.reviewExpandersFrame);
      }

      async init() {
        try {
          const serverReviews = this.readServerReviews();
          const fallbackReviews = this.readFallbackReviews();
          const reviews = serverReviews.length
            ? [...serverReviews, ...fallbackReviews]
            : [...await this.extractReviewsFromSource(), ...fallbackReviews];
          const sourceReviews = this.prepareCompanySourceReviews(reviews);
          this.headingAverage = this.averageRating(sourceReviews);
          const preparedReviews = this.prepareReviews(reviews);
          this.companyReviews = preparedReviews;

          if (!this.companyReviews.length) {
            throw new Error(this.dataset.emptyText || 'Ingen virksomhedsanmeldelser fundet.');
          }

          this.renderReviews();
          const translatedReviews = await this.translateReviews(preparedReviews);
          this.companyReviews = translatedReviews;
          this.renderReviews();
          if (serverReviews.length) this.enhanceReviews(serverReviews);
        } catch (error) {
          this.loading.hidden = true;
          this.error.textContent = error.message || this.dataset.errorText || 'Anmeldelserne kunne ikke indlæses lige nu.';
          this.error.hidden = false;
        }
      }

      readServerReviews() {
        const source = this.querySelector('[data-judgeme-store-reviews]');
        if (!source?.textContent.trim()) return [];
        try {
          const data = JSON.parse(source.textContent);
          this.totalReviewCount = Number(data.number_of_shop_reviews || data.shop_reviews_pagination?.total_count) || 0;
          return Array.isArray(data.shop_reviews)
            ? data.shop_reviews.map((review) => ({ ...review, product_id: 0 }))
            : [];
        } catch {
          return [];
        }
      }

      readFallbackReviews() {
        const source = this.querySelector('[data-company-review-fallbacks]');
        if (!source?.textContent.trim()) return [];
        try {
          const reviews = JSON.parse(source.textContent);
          return Array.isArray(reviews) ? reviews : [];
        } catch {
          return [];
        }
      }

      async translateReviews(reviews) {
        const reviewIds = [...new Set(reviews.map((review) => String(review.uuid || '').trim()).filter(Boolean))];
        const missingIds = reviewIds.filter((reviewId) => !this.translationCache.has(reviewId));

        if (missingIds.length && this.targetLanguage) {
          try {
            const apiHost = window.jdgm?.API_HOST || 'https://api.judge.me/';
            const endpoint = new URL('api/review_translations', apiHost);
            endpoint.search = new URLSearchParams({
              review_uuids: missingIds.join(','),
              language: this.targetLanguage,
              page: '-1',
              shop_domain: this.dataset.shopDomain || '',
              platform: 'shopify'
            }).toString();
            const response = await fetch(endpoint, {
              credentials: 'omit',
              headers: { Accept: 'application/json' }
            });
            if (!response.ok) throw new Error('Judge.me translation request failed.');
            const translations = await response.json();
            missingIds.forEach((reviewId) => this.translationCache.set(reviewId, translations[reviewId] || null));
            this.persistTranslationCache();
          } catch {
            missingIds.forEach((reviewId) => this.translationCache.set(reviewId, null));
          }
        }

        return reviews.map((review) => {
          const translation = this.translationCache.get(String(review.uuid || '').trim());
          const translatedBody = translation?.body?.success ? String(translation.body.translated_text || '').trim() : '';
          const translatedTitle = translation?.title?.success ? String(translation.title.translated_text || '').trim() : '';
          if (!translatedBody) return review;
          return {
            ...review,
            title: translatedTitle || review.title,
            body: translatedBody,
            original_body: review.body,
            original_language: review.language || ''
          };
        });
      }

      restoreTranslationCache() {
        try {
          const stored = JSON.parse(window.sessionStorage.getItem(this.translationStorageKey) || '{}');
          Object.entries(stored).forEach(([reviewId, translation]) => {
            this.translationCache.set(reviewId, translation);
          });
        } catch {
          return;
        }
      }

      persistTranslationCache() {
        try {
          window.sessionStorage.setItem(
            this.translationStorageKey,
            JSON.stringify(Object.fromEntries(this.translationCache))
          );
        } catch {
          return;
        }
      }

      prepareReviews(reviews) {
        return this.prepareCompanySourceReviews(reviews)
          .filter((review) => Number(review.rating) >= this.minimumRating)
          .slice(0, this.limit);
      }

      prepareCompanySourceReviews(reviews) {
        const preparedReviews = reviews
          .filter((review) => String(review.body || '').trim())
          .filter((review) => this.isCompanyReview(review))
          .sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
        return this.uniqueReviews(preparedReviews);
      }

      renderReviews() {
        this.renderEditorial();
        this.renderCards();
        this.renderOverview();
        if (!this.tabsBound) {
          this.bindTabs();
          this.tabsBound = true;
        }
        this.clearSliderBindings();
        this.setInitialMode();
        this.loading.hidden = true;
        this.content.hidden = false;
        this.syncReviewExpanders();
      }

      syncReviewExpanders() {
        cancelAnimationFrame(this.reviewExpandersFrame);
        this.reviewExpandersFrame = requestAnimationFrame(() => {
          this.querySelectorAll('[data-review-text]').forEach((text) => {
            const button = text.nextElementSibling;
            if (!button?.matches('[data-review-more]') || text.classList.contains('is-expanded')) return;
            button.hidden = text.scrollHeight <= text.clientHeight + 1;
          });
        });
      }

      async enhanceReviews(serverReviews) {
        try {
          const sourceReviews = await this.extractReviewsFromSource();
          const combinedReviews = [...serverReviews, ...sourceReviews];
          const unfilteredReviews = this.prepareCompanySourceReviews(combinedReviews);
          const enhancedReviews = this.prepareReviews(combinedReviews);
          if (!enhancedReviews.length) return;
          if (!this.headingAverageFromWidget) this.headingAverage = this.averageRating(unfilteredReviews);
          this.companyReviews = await this.translateReviews(enhancedReviews);
          this.renderReviews();
        } catch {
          return;
        }
      }

      async extractReviewsFromSource() {
        const sourceSelector = "[id$='__wubs_judgeme_company_source']";
        for (let attempt = 0; attempt < 50; attempt += 1) {
          const source = document.querySelector(sourceSelector);
          const cards = source ? Array.from(source.querySelectorAll('.jdgm-card:not(.jdgm-clone-before):not(.jdgm-clone-after)')) : [];
          if (cards.length) {
            source.setAttribute('aria-hidden', 'true');
            source.inert = true;
            const ratingSource = source.querySelector('[data-average-rating], .jm-average-rating-display, .jdgm-all-reviews-rating');
            const ratingValue = Number(
              ratingSource?.dataset?.averageRating
              || String(ratingSource?.textContent || '').replace(',', '.').match(/[0-5](?:\.\d+)?/)?.[0]
            );
            if (ratingValue >= 1 && ratingValue <= 5) {
              this.headingAverage = ratingValue;
              this.headingAverageFromWidget = true;
            }
            const carousel = source.querySelector('[data-jdgm-block-id]');
            const carouselReviews = window.jdgmCarouselMode?.[carousel?.dataset.jdgmBlockId]?.reviews || [];
            const reviewMetadata = new Map(
              [...carouselReviews, ...this.readServerReviews()]
                .filter((review) => review.uuid)
                .map((review) => [String(review.uuid), review])
            );
            const reviews = cards.map((card, index) => {
              const productLink = card.querySelector('.jdgm-product-name a');
              return {
                uuid: card.dataset.reviewId || `company-source-${index}`,
                rating: card.querySelectorAll('.jdgm-stars .jdgm-star.jdgm--on').length || 5,
                title: '',
                body: card.querySelector('.jdgm-text')?.innerText.trim() || '',
                reviewer_name: card.querySelector('.jdgm-reviewer-name')?.innerText.trim() || 'Anonym',
                verified_buyer: Boolean(card.querySelector('.jdgm-reviewer-verified-icon')),
                created_at: reviewMetadata.get(String(card.dataset.reviewId || ''))?.created_at || '',
                location_country: reviewMetadata.get(String(card.dataset.reviewId || ''))?.location_country || '',
                location_country_code: reviewMetadata.get(String(card.dataset.reviewId || ''))?.location_country_code || '',
                country_code_show_flag: reviewMetadata.get(String(card.dataset.reviewId || ''))?.country_code_show_flag || '',
                product_id: null,
                product_title: productLink?.innerText.trim() || '',
                product_url: productLink?.href || ''
              };
            });
            source.replaceChildren();
            return reviews;
          }
          await new Promise((resolve) => window.setTimeout(resolve, 160));
        }
        return [];
      }

      isCompanyReview(review) {
        const hasProductId = review.product_id !== null && review.product_id !== undefined && review.product_id !== '';
        if (hasProductId) return Number(review.product_id) === 0;
        const title = String(review.product_title || '').toLocaleLowerCase('da-DK').trim();
        if (title === 'vitadora danmark' || title === 'vitadora') return true;
        const productUrl = String(review.product_url || '').trim();
        if (!title && !productUrl) return true;
        try {
          const url = new URL(productUrl, window.location.origin);
          return url.pathname === '/' || url.pathname === '';
        } catch {
          return false;
        }
      }

      uniqueReviews(reviews) {
        const seen = new Set();
        return reviews.filter((review) => {
          const reviewId = String(review.uuid || '').trim();
          const normalizedBody = String(review.body || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase('da-DK');
          const key = normalizedBody ? [
              String(review.reviewer_name || '').trim().toLocaleLowerCase('da-DK'),
              normalizedBody,
              Number(review.rating) || 0
            ].join('|') : `uuid:${reviewId}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
      }

      reviewSets() {
        return [{ type: 'company', reviews: this.companyReviews }];
      }

      setInitialMode() {
        const mode = this.mode === 'compare' ? 'editorial' : this.mode;
        this.showPanel(mode);
      }

      bindTabs() {
        this.querySelectorAll('[data-review-tab]').forEach((button) => {
          button.addEventListener('click', () => this.showPanel(button.dataset.reviewTab));
        });
      }

      showPanel(name) {
        this.querySelectorAll('[data-review-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.reviewPanel !== name;
        });
        this.querySelectorAll('[data-review-tab]').forEach((button) => {
          const active = button.dataset.reviewTab === name;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
        });
      }

      bindSlider() {
        this.clearSliderBindings();
        this.querySelectorAll('.wubs-company-reviews__group--cards').forEach((group) => {
          const track = group.querySelector('[data-review-track]');
          const section = this.closest('.wubs-company-reviews');
          const previous = group.querySelector('[data-review-prev]') || section?.querySelector('[data-review-prev]');
          const next = group.querySelector('[data-review-next]') || section?.querySelector('[data-review-next]');
          const cards = Array.from(track?.querySelectorAll('.wubs-company-reviews__review-card') || []);
          const reviewCount = Number(track?.dataset.reviewCount) || 0;
          if (!track || !previous || !next || !reviewCount || cards.length < reviewCount * 3) return;

          let currentIndex = reviewCount;
          let scrollTimer = 0;
          let autoTimer = 0;
          let paused = false;
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const itemStep = () => Math.max(1, (cards[1]?.offsetLeft || 0) - (cards[0]?.offsetLeft || 0));
          const itemsPerView = () => Math.max(1, Math.round(track.clientWidth / itemStep()));
          const logicalIndex = () => ((currentIndex - reviewCount) % reviewCount + reviewCount) % reviewCount;
          const syncButtons = () => {
            const hasNoScrollableReviews = reviewCount <= itemsPerView();
            previous.disabled = hasNoScrollableReviews || logicalIndex() === 0;
            next.disabled = hasNoScrollableReviews;
          };
          const setPosition = (index, behavior = 'auto') => {
            currentIndex = Math.max(0, Math.min(cards.length - 1, index));
            track.scrollTo({ left: cards[currentIndex].offsetLeft, behavior });
            syncButtons();
          };
          const normalize = () => {
            currentIndex = Math.round(track.scrollLeft / itemStep());
            if (currentIndex < reviewCount) setPosition(currentIndex + reviewCount);
            if (currentIndex >= reviewCount * 2) setPosition(currentIndex - reviewCount);
          };
          const move = (direction) => {
            if (reviewCount <= itemsPerView()) return;
            setPosition(currentIndex + direction * itemsPerView(), 'smooth');
          };
          const stopAuto = () => {
            window.clearInterval(autoTimer);
            autoTimer = 0;
          };
          const startAuto = () => {
            stopAuto();
            if (paused || reducedMotion || document.hidden || reviewCount <= itemsPerView()) return;
            autoTimer = window.setInterval(() => move(1), 6000);
          };
          const pause = () => {
            paused = true;
            stopAuto();
          };
          const resume = () => {
            paused = false;
            startAuto();
          };
          const update = () => {
            setPosition(currentIndex);
          };
          const onScroll = () => {
            window.clearTimeout(scrollTimer);
            currentIndex = Math.round(track.scrollLeft / itemStep());
            syncButtons();
            scrollTimer = window.setTimeout(normalize, 180);
          };
          const onVisibilityChange = () => document.hidden ? stopAuto() : startAuto();
          const onFocusOut = (event) => {
            if (!group.contains(event.relatedTarget)) resume();
          };

          previous.addEventListener('click', () => move(-1));
          next.addEventListener('click', () => move(1));
          track.addEventListener('scroll', onScroll, { passive: true });
          group.addEventListener('pointerenter', pause);
          group.addEventListener('pointerleave', resume);
          group.addEventListener('focusin', pause);
          group.addEventListener('focusout', onFocusOut);
          window.addEventListener('resize', update, { passive: true });
          document.addEventListener('visibilitychange', onVisibilityChange);
          requestAnimationFrame(() => {
            setPosition(reviewCount);
            update();
            startAuto();
          });

          this.sliderCleanups.push(() => {
            stopAuto();
            window.clearTimeout(scrollTimer);
            window.removeEventListener('resize', update);
            document.removeEventListener('visibilitychange', onVisibilityChange);
          });
        });
      }

      clearSliderBindings() {
        (this.sliderCleanups || []).forEach((cleanup) => cleanup());
        this.sliderCleanups = [];
      }

      renderEditorial() {
        const container = this.querySelector('.wubs-company-reviews__editorial-groups');
        container.classList.add('wubs-company-reviews__groups');
        container.innerHTML = this.reviewSets().map(({ type, reviews }) => {
          const main = reviews[0];
          const secondary = reviews.slice(1, 3);
          return `
            <section class="wubs-company-reviews__group">
              ${this.groupHeader(type, reviews.length)}
              <div class="wubs-company-reviews__editorial">
                <article class="wubs-company-reviews__feature">
                  <div>
                    <div class="wubs-company-reviews__feature-top">
                      ${this.stars(main.rating)}
                    </div>
                    <blockquote>“${this.escape(main.body)}”</blockquote>
                    ${this.productLink(main, type)}
                  </div>
                  <footer class="wubs-company-reviews__feature-footer">
                    ${this.person(main)}
                    <span class="wubs-company-reviews__flag" role="img" aria-label="Danmark"></span>
                  </footer>
                </article>
                ${secondary.length ? `
                  <div class="wubs-company-reviews__side">
                    ${secondary.map((review) => `
                      <article class="wubs-company-reviews__mini">
                        <div>
                          ${this.stars(review.rating)}
                          <p>“${this.escape(review.body)}”</p>
                          ${this.productLink(review, type)}
                        </div>
                        ${this.person(review)}
                      </article>
                    `).join('')}
                  </div>
                ` : ''}
              </div>
            </section>
          `;
        }).join('');
      }

      renderCards() {
        const reviewSets = this.reviewSets();
        const section = this.closest('.wubs-company-reviews');
        const summaryAverage = section?.querySelector('[data-review-average]');
        const summaryCount = section?.querySelector('[data-review-count]');
        if (reviewSets.length) {
          const reviews = reviewSets[0].reviews;
          const average = Math.ceil((Number(this.dataset.summaryAverage) || this.headingAverage || this.averageRating(reviews)) * 10) / 10;
          const total = Number(this.dataset.summaryCount) || this.totalReviewCount || reviews.length;
          if (summaryAverage) summaryAverage.textContent = `${average.toFixed(1).replace('.', ',')} / 5`;
          if (summaryCount) summaryCount.textContent = this.formatCount(total);
          const summary = { average, count: total };
          window.wubsCompanyReviewSummary = summary;
          document.dispatchEvent(new CustomEvent('wubs:company-review-summary', { detail: summary }));
        }
        this.querySelector('.wubs-company-reviews__cards').innerHTML = `
          <div class="wubs-company-reviews__groups">
            ${reviewSets.map(({ type, reviews }) => {
              const visibleReviews = reviews.slice(0, this.visibleCount);
              const renderCard = (review) => `
                <article class="wubs-company-reviews__review-card">
                  ${this.stars(review.rating)}
                  <blockquote class="wubs-company-reviews__review-text" data-review-text>“${this.escape(review.body)}”</blockquote>
                  <button class="wubs-company-reviews__read-more" type="button" data-review-more aria-expanded="false" hidden>Læs mere</button>
                  ${this.productLink(review, type)}
                  ${this.person(review)}
                </article>
              `;
              return `
                <section class="wubs-company-reviews__group wubs-company-reviews__group--cards">
                  <div class="wubs-company-reviews__track">
                    ${visibleReviews.map((review) => renderCard(review)).join('')}
                  </div>
                </section>
              `;
            }).join('')}
          </div>
        `;
      }

      renderOverview() {
        const container = this.querySelector('.wubs-company-reviews__overview-groups');
        container.classList.add('wubs-company-reviews__groups');
        container.innerHTML = this.reviewSets().map(({ type, reviews }) => {
          const average = this.averageRating(reviews);
          const counts = [5, 4, 3, 2, 1].map((rating) => ({
            rating,
            count: reviews.filter((review) => Number(review.rating) === rating).length
          }));
          const maxCount = Math.max(...counts.map((item) => item.count), 1);
          const listReviews = reviews.slice(0, 4);
          return `
            <section class="wubs-company-reviews__group">
              ${this.groupHeader(type, reviews.length)}
              <div class="wubs-company-reviews__overview">
                <aside class="wubs-company-reviews__summary">
                  <span class="wubs-company-reviews__summary-number">${(Math.ceil(average * 10) / 10).toFixed(1).replace('.', ',')}</span>
                  ${this.stars(Math.round(average))}
                  <p class="wubs-company-reviews__summary-label">${type === 'company' ? 'Helhedsoplevelsen hos Vitadora' : 'Kundernes oplevelse af produkterne'}</p>
                  <div class="wubs-company-reviews__bars">
                    ${counts.map((item) => `
                      <div class="wubs-company-reviews__bar">
                        <span>${item.rating}</span>
                        <span class="wubs-company-reviews__bar-track"><span class="wubs-company-reviews__bar-fill" style="width:${(item.count / maxCount) * 100}%"></span></span>
                        <span>${item.count}</span>
                      </div>
                    `).join('')}
                  </div>
                </aside>
                <div class="wubs-company-reviews__list">
                  ${listReviews.map((review) => `
                    <article class="wubs-company-reviews__list-item">
                      <div>
                        ${this.stars(review.rating)}
                        <strong>${this.escape(review.reviewer_name || 'Anonym')}</strong>
                        <small>${this.formatDate(review.created_at)}</small>
                      </div>
                      <div>
                        ${this.productLink(review, type)}
                        <p>“${this.escape(review.body)}”</p>
                      </div>
                    </article>
                  `).join('')}
                </div>
              </div>
            </section>
          `;
        }).join('');
      }

      groupHeader(type, count) {
        const isCompany = type === 'company';
        return `
          <header class="wubs-company-reviews__group-header">
            <div>
              <h3>${isCompany ? 'Om Vitadora' : 'Om produkterne'}</h3>
            </div>
            <span class="wubs-company-reviews__group-count">${count} ${count === 1 ? 'anmeldelse' : 'anmeldelser'}</span>
          </header>
        `;
      }

      averageRating(reviews) {
        if (!reviews.length) return 0;
        return reviews.reduce((sum, review) => sum + Number(review.rating || 0), 0) / reviews.length;
      }

      formatCount(value) {
        return new Intl.NumberFormat('da-DK').format(Number(value) || 0);
      }

      productLink(review, type) {
        if (type !== 'product') return '';
        const title = String(review.product_title || 'Se produktet').trim();
        const href = this.safeProductUrl(review.product_url);
        const content = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17 17 7"></path><path d="M7 7h10v10"></path></svg>${this.escape(title)}`;
        return href
          ? `<a class="wubs-company-reviews__product-link" href="${this.escape(href)}">${content}</a>`
          : `<span class="wubs-company-reviews__product-link">${content}</span>`;
      }

      safeProductUrl(value) {
        const raw = String(value || '').trim();
        if (!raw) return '';
        try {
          const url = new URL(raw, window.location.origin);
          return url.origin === window.location.origin && url.pathname.startsWith('/products/') ? url.href : '';
        } catch {
          return '';
        }
      }

      reviewCountry(review) {
        const code = String(review.location_country_code || review.country_code_show_flag || '').trim().toUpperCase();
        if (code) {
          if (!/^[A-Z]{2}$/.test(code) || ['ZZ', 'XX', 'EU', 'UN', 'QO', 'XA', 'XB'].includes(code)) return '';
          try {
            const locale = this.dataset.locale || document.documentElement.lang || 'en';
            return new Intl.DisplayNames([locale], { type: 'region', fallback: 'none' }).of(code) || '';
          } catch {
            return String(review.location_country || '').trim();
          }
        }
        return String(review.location_country || '').trim();
      }

      person(review) {
        const name = review.reviewer_name || 'Anonym';
        const initial = name.trim().charAt(0).toLocaleUpperCase('da-DK') || 'A';
        const locationMeta = [this.formatDate(review.created_at), this.reviewCountry(review)]
          .filter(Boolean)
          .map((value) => this.escape(value))
          .join(' · ');
        return `
          <div class="wubs-company-reviews__person">
            <span class="wubs-company-reviews__avatar" aria-hidden="true">${this.escape(initial)}</span>
            <span>
              <strong>${this.escape(name)}</strong>
              ${locationMeta ? `<small>${locationMeta}</small>` : ''}
              ${review.verified_buyer ? `<small>${this.verifiedBadge()}</small>` : ''}
            </span>
          </div>
        `;
      }

      verifiedBadge() {
        return `<span class="wubs-company-reviews__verified"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="m8 12 2.6 2.6L16.5 9"></path></svg>Verificeret kunde</span>`;
      }

      stars(rating) {
        const rounded = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
        return `<span class="wubs-company-reviews__stars" aria-label="${rounded} ud af 5 stjerner"><span aria-hidden="true">${'★'.repeat(rounded)}<span class="is-empty">${'★'.repeat(5 - rounded)}</span></span></span>`;
      }

      formatDate(value) {
        if (!value) return '';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '';
        return new Intl.DateTimeFormat('da-DK', { day: 'numeric', month: 'short', year: 'numeric' }).format(date);
      }

      escape(value) {
        const node = document.createElement('span');
        node.textContent = String(value || '');
        return node.innerHTML;
      }
    }

    customElements.define('wubs-company-review-showcase', WubsCompanyReviewShowcase);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wubs-radskort"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wubs-about-review-summary')) {
    class WubsAboutReviewSummary extends HTMLElement {
      connectedCallback() {
        this.onSummary = (event) => this.renderSummary(event.detail);
        document.addEventListener('wubs:company-review-summary', this.onSummary);
        this.renderSummary(window.wubsCompanyReviewSummary || {
          count: Number(this.dataset.count),
          average: Number(this.dataset.average)
        });
      }

      disconnectedCallback() {
        document.removeEventListener('wubs:company-review-summary', this.onSummary);
      }

      renderSummary(summary = {}) {
        const locale = this.dataset.locale || document.documentElement.lang || 'en';
        if (Number.isFinite(summary.count) && summary.count > 0) {
          const count = new Intl.NumberFormat(locale).format(summary.count);
          this.querySelectorAll('[data-company-review-count]').forEach((element) => {
            element.textContent = count;
          });
        }
        if (Number.isFinite(summary.average) && summary.average > 0 && summary.average <= 5) {
          const average = new Intl.NumberFormat(locale, {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
          }).format(Math.ceil(summary.average * 10) / 10);
          this.closest('.wubs-radskort')?.querySelectorAll('[data-company-review-average]').forEach((element) => {
            element.textContent = average;
          });
        }
      }
    }
    customElements.define('wubs-about-review-summary', WubsAboutReviewSummary);
  }

  } catch(e) { console.error(e); }
})();
})();
